<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
            <b-button v-if="IsAdmin()" variant="primary" v-b-modal.addModal>
              <feather-icon icon="PlusIcon" class="mr-50" />
              Import Attendance
            </b-button>

            <b-button
              variant="primary"
              class="ml-2"
              v-if="IsAdmin()"
              v-b-modal.modal-add-attendance
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add Attendance
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :current-page="currentPage"
              :items="filteredAttendance"
              :fields="attendance_fields"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <!-- <template #cell(employeeID)="data">
                {{ getEmployeeName(data.item.employeeID) }}
                
                <span v-show="false">{{ getManagerName(data.item.employeeID) }}</span>

              </template> -->

              <template #cell(employeeName)="data">
                {{ data.item.employeeName }}
              </template>

              <template v-slot:cell(date)="data">
                {{ convertTimestampToDate(data.item.date) }}
              </template>

              <template v-slot:cell(clockInTime)="data">
                {{ convertTimestampToTime(data.item.clockInTime) }}
              </template>

              <template v-slot:cell(clockOutTime)="data">
                {{ convertTimestampToTime(data.item.clockOutTime) }}
              </template>

              <template v-slot:cell(hoursWorked)="data">
                {{
                  getHoursWorked(data.item.clockInTime, data.item.clockOutTime)
                }}
              </template>

              <template #cell(status)="data">
                <div
                  class="d-flex align-items-center"
                  v-if="!data.item.editingStatus"
                  @click="editStatusField(data.item, 'editingStatus')"
                >
                  <b-badge :variant="getStatusColor(data.item.status)">
                    {{ data.item.status }}
                  </b-badge>
                  <feather-icon v-if="IsAdmin()" icon="EditIcon" class="ml-2" />
                </div>
                <div v-else>
                  <b-form-select
                    :disabled="!IsAdmin()"
                    v-model="data.item.status"
                    :options="statusOptions"
                    @change="saveStatusField(data.item, 'editingStatus')"
                  />
                </div>
              </template>

              <!-- Cell template for 'remarks' field -->
              <template #cell(notes)="data">
                <div
                  class="d-flex align-items-center"
                  v-if="!data.item.editingRemarks"
                  @click="editRemarkField(data.item, 'editingRemarks')"
                >
                  <span>{{ data.item.notes }}</span>
                  <feather-icon v-if="IsAdmin()" icon="EditIcon" class="ml-2" />
                </div>
                <div v-else>
                  <b-form-input
                    :disabled="!IsAdmin()"
                    v-model="data.item.notes"
                    @blur="saveRemarkField(data.item, 'editingRemarks')"
                  />
                </div>
              </template>

              <template v-slot:cell(actions)="">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-b-modal.modal-edit-timesheet
                    v-if="IsAdmin()"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- <b-modal
              id="modal-edit-timesheet"
              ok-only
              ok-title="Edit"
              centered
              size="lg"
              title="Edit timesheet"
              :hide-footer="true"
              ref="editTimesheet"
            >
              <EditAttendance @refresh="refreshData" />
            </b-modal> -->
          </b-col>

          <b-modal
            id="addModal"
            title="Import Attendance"
            v-model="showAddModal"
            cancel-title="Close"
            hide-footer
            centered
            @hidden="resetForm"
          >
            <b-form @submit.prevent="ImportAttendance">
              <b-row>
                <div class="m-4">
                  <b-form-group label="Upload File" label-for="file-input ">
                    <b-form-file
                      id="file-input"
                      v-model="file"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    />
                  </b-form-group>

                  <!-- Display Selected File -->
                  <b-card-text class="my-1">
                    Selected file:
                    <strong>{{ file ? file.name : "No file selected" }}</strong>
                  </b-card-text>
                </div>
                <!-- File Input -->

              </b-row>

              <div class="d-flex justify-content-end">
                <b-button variant="info" class="mr-2">
                  <a
                    :href="'/csv/' + csvFiles['Attendance Data']"
                    download
                    target="_blank"
                    class="text-white"
                  >
                    <feather-icon icon="EyeIcon" /> View Format
                  </a>
                </b-button>

                <b-button
                  variant="secondary"
                  @click="closeImportmodal()"
                  class="mr-2"
                  >Cancel</b-button
                >
                <b-button
                  type="button"
                  @click="ImportAttendance()"
                  variant="primary"
                  >Submit</b-button
                >
              </div>
            </b-form>
          </b-modal>

          <b-modal
            ref="modalAddAttendance"
            id="modal-add-attendance"
            title="Add Attendance"
            @submit.prevent="addAttendance"
            hide-footer
            centered
          >
            <!-- <label style="color: red;">{{ userData.fullName }}, You haven't clocked in yet!</label> -->

            <!-- ().then((success) => success && addAttendance()) -->

            <validation-observer ref="addAttendanceForm" #default="{ invalid }">
              <b-form @submit.prevent="addAttendance">
                <b-form-group label="Employee Name*" label-for="name">
                  <validation-provider
                    name="Employee Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <!-- {{ employeeId }} -->
                    <b-form-select
                      id="name"
                      v-model="employeeId"
                      value-field="id"
                      text-field="fullName"
                      :options="formattedEmployeeOptions"
                      @change="employeeSelected(employeeId)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Date" label-for="date">
                  <!-- <b-form-input id="date" v-model="this.newAttendance.date" /> -->
                  <b-form-datepicker
                    v-model="newAttendance.date"
                    placeholder="Select Date"
                    size="sm"
                    class="mt-1"
                    @input="currentPage = 1"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                  />
                </b-form-group>
                <b-form-group label="Clock In Time*" label-for="clockintime">
                  <validation-provider
                    name="Clock In Time"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-timepicker
                      id="clockintime"
                      :min="new Date()"
                      v-model="newAttendance.clockintime"
                      locale="en"
                    ></b-form-timepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Clock Out Time*" label-for="clockouttime">
                  <validation-provider
                    name="Clock Out Time"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-timepicker
                      id="clockouttime"
                      :min="new Date()"
                      v-model="newAttendance.clockouttime"
                      locale="en"
                    ></b-form-timepicker>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <!-- <b-form-input id="clockouttime" v-model="clockouttime" /> -->
                </b-form-group>
                <b-form-group label="Status*" label-for="status">
                  <validation-provider
                    name="Status"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-select
                      id="status"
                      v-model="newAttendance.status"
                      :options="statusOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Comment*" label-for="comment">
                  <validation-provider
                    name="Comment"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="comment"
                      v-model="newAttendance.comment"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="loading"
                  @click="addAttendance()"
                >
                  Submit
                </b-button>
              </b-form>
            </validation-observer>
          </b-modal>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
          <b-form-group>
            Showing
            {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
            to
            {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }}
            of
            {{ totalRows > 0 ? totalRows : 0 }}
            entries
          </b-form-group>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { t } from "@/@core/libs/i18n/utils";
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BFormFile,
  BDropdownItem,
  BTab,
  BTabs,
  BFormTimepicker,
  BFormDatepicker,BImg,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import { customLoader, customSwal, customError } from "@/libs/customFn";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BFormFile,
    BDropdownItem,
    BTab,
    BTabs,
    BFormTimepicker,
    BFormDatepicker,
    ValidationObserver,
    ValidationProvider,BImg,
  },
  // props: {
  //   employeeId: {
  //     default: () => null
  //   }
  // },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")) || {},
      filteredAttendance: [],
      file: null,
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: null,
      sortDesc: null,
      sortDirection: null,
      filter: null,
      filterOn: [],
      employeeUser: null,
      employeeId: null,
      whenSelected: [],
      //userData: localStorage.getItem("userData"),
      attendance_fields: IsAdmin()
        ? [
            { key: "employeeName", label: "Employee Name", sortable: true },
            { key: "date", label: "Clock-In/Out Dates", sortable: true },
            { key: "clockInTime", label: "Clock-In Time", sortable: true },
            { key: "clockOutTime", label: "Clock-Out Time", sortable: true },
            { key: "clockInLocation", label: "Location", sortable: true },
            { key: "status", label: "Status", sortable: true },
            { key: "notes", label: "Remarks", sortable: true },
            {
              key: "totalMinutesWorked",
              label: "Hours Worked",
              sortable: true,
            },
            { key: "overtimeHours", label: "Overtime", sortable: true },
          ]
        : [
            { key: "employeeName", label: "Employee Name", sortable: true },
            { key: "date", label: "Clock-In/Out Dates", sortable: true },
            { key: "clockInTime", label: "Clock-In Time", sortable: true },
            { key: "clockOutTime", label: "Clock-Out Time", sortable: true },
            { key: "clockInLocation", label: "Location", sortable: true },
            { key: "status", label: "Status", sortable: true },
            { key: "notes", label: "Remarks", sortable: true },
            {
              key: "totalMinutesWorked",
              label: "Hours Worked",
              sortable: true,
            },
            { key: "overtimeHours", label: "Overtime", sortable: true },
          ],
      //   attendance_fields: IsAdmin()
      // ? [
      //     { key: "employeeName", label: "Employee Name", sortable: true },
      //     { key: "date", label: "Clock-In/Out Dates", sortable: true },
      //     { key: "clockInTime", label: "Clock-In Time", sortable: true },
      //     { key: "clockOutTime", label: "Clock-Out Time", sortable: true },
      //     { key: "clockInLocation", label: "Location", sortable: true },
      //     { key: "status", label: "Status", sortable: true },
      //     { key: "notes", label: "Remarks", sortable: true },
      //     { key: "hoursWorked", label: "Hours Worked", sortable: true },
      //     { key: "overtimeHours", label: "Overtime", sortable: true },
      //   ]
      // : [
      //     { key: "employeeName", label: "Employee Name", sortable: true },
      //     { key: "date", label: "Clock-In/Out Dates", sortable: true },
      //     { key: "clockInTime", label: "Clock-In Time", sortable: true },
      //     { key: "clockOutTime", label: "Clock-Out Time", sortable: true },
      //     { key: "clockInLocation", label: "Location", sortable: true },
      //     { key: "status", label: "Status", sortable: true },
      //     { key: "notes", label: "Remarks", sortable: true },
      //     { key: "hoursWorked", label: "Hours Worked", sortable: true },
      //     { key: "overtimeHours", label: "Overtime", sortable: true },
      //   ],

      getManager: null,
      status: [
        {
          PRESENT: "PRESENT",
          ABSENT: "ABSENT",
        },
        {
          1: "light-success",
          2: "light-danger",
        },
      ],
      statusOptions: [
        { value: "PRESENT", text: "Present" },
        { value: "ABSENT", text: "Absent" },
      ],
      currentAttendance: null,
      defaultAttendance: {
        employeeID: null,
        name: this.getName(),
        date: this.getCurrentDate(),
        clockintime: null,
        status: "PRESENT",
        comment: null,
      },
      newAttendance: {
        employeeID: null,
        name: this.getName(),
        date: this.getCurrentDate(),
        clockintime: null,
        status: "PRESENT",
        comment: null,
      },
      location: null,
      clockedIn: new Date().toISOString(),

      // categories: [
      //   {
      //     title: "Attendance Data",
      //     icon: "attendance",
      //     download: true,
      //     exampleLink: "",
      //     downloadLink: "attendance/download",
      //     uploadLink: "",
      //     export: true,
      //     uploadedFiles: [],
      //   },
      // ],
      csvFiles: {
        "Attendance Data": "Attendance-copy.csv",
      },
    };
  },

  computed: {
    ...mapGetters("attendanceModule", {
      attendance_items: "attendance",
      loading: "loading",
    }),

    ...mapGetters("employeeModule", {
      employeeList: "employees",
      employee: "employeeid",
      loading: "loading",
    }),

    formattedEmployeeOptions() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      return this.employeeList
        .filter((x) => IsAdmin() || x.refId != userData.id)
        .map((employee) => {
          if (employee.id != this.employeeId) {
            return {
              ...employee,
              fullName: `${employee.firstName} ${employee.lastName}`,
            };
          } else {
            return {
              ...employee,
              fullName: `${employee.firstName} ${employee.lastName}`,
            };
          }
        });
    },

    async formattedAttendance() {
      if (this.IsAdmin()) {
        // Admin can see all records
        return this.attendance_items
          .filter((item) => {
            if (this.IsAdmin()) {
              return true; // Admin can see all records
            }
            return item.employeeID === this.$store.getters["auth/user"].id;
          })
          .map((item) => {
            const employee = this.employeeList.find(
              (emp) => emp.id === item.employeeID
            );
            return {
              ...item,
              employeeName: employee
                ? `${employee.firstName} ${employee.lastName}`
                : "",
              totalMinutesWorked: this.getTotalMinutesWorked(
                item.clockInTime,
                item.clockOutTime
              ).toFixed(2), // Add numeric value
            };
          });
      } else {
        // Non-admin users only see their own attendance
        const userData = JSON.parse(localStorage.getItem("userData"));
        const emp = await this.getUser(userData.id); // Get mapped employee ID
        console.log("emp computed", emp);
        console.log("attendance_items computed", await this.attendance_items);
        await this.attendance_items.filter((x) => x.employeeID == emp);
        console.log("attendance_items non admin", await this.attendance_items);
        return await this.attendance_items.map((item) => {
          return {
            ...item,
            employeeName: employee
              ? `${employee.firstName} ${employee.lastName}`
              : "",
            totalMinutesWorked: this.getTotalMinutesWorked(
              item.clockInTime,
              item.clockOutTime
            ), // Add numeric value
          };
        });
      }
    },
  },

  methods: {
    ...mapActions("attendanceModule", [
      "getAttendanceListAction",
      "addAttendanceAction",
      "updateAttendanceAction",
      "importAttendanceAction",
    ]),
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
      "getEmployeeByIdAction",
    ]),
    async employeeSelected(id) {
      await this.getEmployeeByIdAction(id).then(() => {
        this.whenSelected = this.employee;
      });
    },
    async getUser(id) {
      //console.log("idddddddddddddddddd", id);
      const user = this.employeeList.find((s) => s.refId === id);
      //console.log("userrrrrrrrrrrrrrrrrr", user.id);
      return user.id;
    },

    closeImportmodal() {
      //importModal
      this.file = "";
      this.$bvModal.hide("addModal");
    },

    resetForm() {
    this.file = "";
  },
  
    ImportAttendance() {
      let docForm = new FormData();

      docForm.append("File", this.file);
      console.log("File", this.file);

      this.importAttendanceAction(docForm)
        .then(() => {
          this.successAdd();
          this.$bvModal.hide("addModal");
          this.showAddModal = false;
          this.getAttendanceListAction({ id: null, date: null }).then(() => {
            this.filteredAttendance = this.attendance_items.map((item) => {
              const employee = this.employeeList.find(
                (emp) => emp.id === item.employeeID
              );
              return {
                ...item,
                employeeName: employee
                  ? `${employee.firstName} ${employee.lastName}`
                  : "Unknown",
                totalMinutesWorked: item.hoursWorked,
              };
            });
            this.totalRows = this.filteredAttendance.length;
          });
          this.file = null;
          this.$bvModal.hide("addModal");
        })
        .catch((error) => {
          console.log(error);
          // Extract the error message from the response
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "An unexpected error occurred.";

          this.$swal({
            icon: "error",
            title: "Error!",
            text: errorMessage, // Display the extracted error message
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.showAddModal = false;

          this.getAttendanceListAction({ id: null, date: null }).then(() => {
            this.filteredAttendance = this.attendance_items.map((item) => {
              const employee = this.employeeList.find(
                (emp) => emp.id === item.employeeID
              );
              return {
                ...item,
                employeeName: employee
                  ? `${employee.firstName} ${employee.lastName}`
                  : "Unknown",
                totalMinutesWorked: item.hoursWorked,
              };
            });
            this.totalRows = this.filteredAttendance.length;
          });
          //this.errorAdd();
        });
    },

    setTimer(date) {
      console.log("🚀 ~ setTimer ~ date:", date);
      let currentTime = new Date();
      console.log(currentTime, date);

      if (date) {
        let diffInMs = currentTime - new Date(date);
        let diffInSeconds = Math.floor(diffInMs / 1000);
        this.hours = Math.floor(diffInSeconds / 3600);
        this.minutes = Math.floor((diffInSeconds % 3600) / 60);
        this.seconds = diffInSeconds % 60;
      }

      if (!this.timerRunning) {
        this.timerRunning = true;
        this.timer = setInterval(() => {
          this.seconds++;
          if (this.seconds === 60) {
            this.seconds = 0;
            this.minutes++;
          }
          if (this.minutes === 60) {
            this.minutes = 0;
            this.hours++;
          }
        }, 1000);
      }
    },

    async clockIn() {
      this.setTimer();
      this.clockedIn = new Date().toISOString();
    },

    //  getclockinTime(){
    //   this.newAttendance.clockInTime = new Date().toISOString();
    //  },

    getName() {
      const userData = JSON.parse(localStorage.getItem("userData"));

      this.employeeID = userData.id;
      return userData.fullName;
    },

    async addAttendance() {
      this.loading = true;
      const isValid = await this.$refs.addAttendanceForm.validate();
      if (isValid) {
      
        const selectedDate = new Date(this.newAttendance.date);
    const today = new Date();
    
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      this.loading = false;
      customError("You cannot add attendance for a future date.");
      return;
    }
        let loader = customLoader("Adding Attendance...");
        
        let payload = {
          employeeID: this.employeeId,
          date: this.newAttendance.date, 
          clockInTime: this.newAttendance.clockintime
            ? `${this.newAttendance.date}T${this.newAttendance.clockintime}`
            : null, 
          clockInLocation: "MANUAL",
          // clockOutLocation: this.location,
          clockOutTime: this.newAttendance.clockouttime
            ? `${this.newAttendance.date}T${this.newAttendance.clockouttime}`
            : null, 
          //hoursWorked: `${formattedHours}:${formattedMinutes}`,
          hoursWorked: 0.0,
          status: "PRESENT",
        };

        this.addAttendanceAction(payload)
          .then((response) => {
            this.loading = false;

            if (response.success) {
              this.id = payload.id;
              this.$bvModal.hide("modal-add-attendance");
          //     this.resetAddForm();
          //     console.log("empppppppppp");
          //     this.getAttendanceListAction({ id: null, date: null }).then(() => {
                
          //   this.totalRows = this.attendance_items.length;
          // });
              // this.getAttendanceListAction({ id: null, date: null }).then(
              //   () => {
              //     this.filteredAttendance = this.attendance_items.map(
              //       (item) => {
              //         const employee = this.employeeList.find(
              //           (emp) => emp.id === item.employeeID
              //         );
              //         return {
              //           ...item,
              //           employeeName: employee
              //             ? `${employee.firstName} ${employee.lastName}`
              //             : "Unknown",
              //           totalMinutesWorked: item.hoursWorked,
              //         };
              //       }
              //     );
              //     this.totalRows = this.filteredAttendance.length;
              //   }
              // );
              customSwal("Attendance has been added!");
              //this.resetAddForm();
            } else {
              customError(response.message);
            }
            this.$bvModal.hide("modal-add-attendance");
            this.resetAddForm();
            this.getAttendanceListAction({ id: null, date: null }).then(
                () => {
                  this.filteredAttendance = this.attendance_items.map(
                    (item) => {
                      const employee = this.employeeList.find(
                        (emp) => emp.id === item.employeeID
                      );
                      return {
                        ...item,
                        employeeName: employee
                          ? `${employee.firstName} ${employee.lastName}`
                          : "Unknown",
                        totalMinutesWorked: item.hoursWorked,
                      };
                    }
                  );
                  this.totalRows = this.filteredAttendance.length;
                }
              );


            this.newAttendance = this.defaultAttendance;
            loader.close();
          })
          .catch((error) => {
            this.clockedIn = null;
            loader.close();
          
            //customError(error.response.data);
            this.$bvModal.hide("modal-add-attendance");
            this.resetAddForm();
            this.getAttendanceListAction({ id: null, date: null }).then(
                () => {
                  this.filteredAttendance = this.attendance_items.map(
                    (item) => {
                      const employee = this.employeeList.find(
                        (emp) => emp.id === item.employeeID
                      );
                      return {
                        ...item,
                        employeeName: employee
                          ? `${employee.firstName} ${employee.lastName}`
                          : "Unknown",
                        totalMinutesWorked: item.hoursWorked,
                      };
                    }
                  );
                  this.totalRows = this.filteredAttendance.length;
                }
              );

          });
      }
    },

    resetAddForm() {
          (this.employeeId = null),
            (this.newAttendance.date= null),
            (this.newAttendance.clockintime = null),
            (this.newAttendance.clockouttime = null),
            (this.newAttendance.status = null),
            (this.newAttendance.comment = null);
        },

    successAdd() {
      this.$swal({
        title: "Import Attendance!",
        text: "You have successfully Import Attendance!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getStatusColor(status) {
      switch (status) {
        case "ABSENT":
          return "warning";
        case "PRESENT":
          return "success";
        default:
          return "secondary";
      }
    },

    getEmployeeName(id) {
      const employee = this.employeeList.find((s) => s.id === id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },

    getManagerName(id) {
      console.log("id", id);
      const employee = this.employeeList.find((s) => s.refId === id);
      console.log("employee", employee);
      return employee ? employee.refId : "-";
    },

    convertTimestampToDate(timestamp) {
      if (timestamp === null) {
        return "-";
      }
      return new Date(timestamp).toLocaleDateString();
    },

    // convertTimestampToTime(timestamp) {
    //       if (timestamp === null) {
    //         return '-';
    //       }
    //       const date = new Date(timestamp);

    // const mauritianTime = new Date(date.getTime() + 4 * 60 * 60 * 1000);

    // const options = { hour: '2-digit', minute: '2-digit' };
    // const timeInMauritius = mauritianTime.toLocaleTimeString([], options);

    // return timeInMauritius;
    //     },

    convertTimestampToTime(timestamp) {
      if (timestamp === null) {
        return "-";
      }

      // Ensure the timestamp is parsed as a valid Date object.
      const date = new Date(timestamp);

      //const mauritianTime = new Date(date.getTime() + 4 * 60 * 60 * 1000);

      const options = { hour: "2-digit", minute: "2-digit" };
      const timeInMauritius = date.toLocaleTimeString([], options);

      // Use Intl.DateTimeFormat to format the date correctly
      //const timeInMauritius = new Intl.DateTimeFormat('en-US', options).format(mauritianTime);

      return timeInMauritius;
    },

    //     getHoursWorked(clockin, clockout){
    //       if(clockout === null){
    //         return '-';
    //       }

    //         const datein = new Date(clockin);
    //         const dateout = new Date(clockout);

    // const mauritianTimeIN = new Date(datein.getTime() + 4 * 60 * 60 * 1000);
    // const mauritianTimeOUT = new Date(dateout.getTime() + 4 * 60 * 60 * 1000);

    // const options = { hour: '2-digit', minute: '2-digit' };
    // const timeInMauritiusIN = mauritianTimeIN.toLocaleTimeString([], options);
    // const timeInMauritiusOUT = mauritianTimeOUT.toLocaleTimeString([], options);

    // const timeDifference = mauritianTimeOUT - mauritianTimeIN;

    // // Convert milliseconds to hours and minutes
    // const hoursWorked = Math.floor(timeDifference / (1000 * 60 * 60)); // Convert to hours
    // const minutesWorked = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)); // Get remaining minutes

    // // Return formatted result
    // return `${hoursWorked} hours ${minutesWorked} minutes`;

    //     },
    getTotalMinutesWorked(clockin, clockout) {
      if (clockout === null || clockin === null) {
        return 0; // Return 0 if no clock-out time is present
      }

      const clockInTime = new Date(clockin);
      const clockOutTime = new Date(clockout);

      const timeDifference = (clockOutTime - clockInTime) / (1000 * 60); // Convert to minutes
      return Math.max(0, timeDifference); // Ensure non-negative values
    },

    getHoursWorked(clockin, clockout) {
      if (clockout === null || clockin === null) {
        return "-";
      }

      const totalMinutes = this.getTotalMinutesWorked(clockin, clockout);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours} hours ${minutes} minutes`;
    },

    onFiltered(filteredItems) {
      // Handle filtered items if needed
    },

    editStatusField(item, field) {
      if (IsAdmin()) {
        this.$set(item, field, true);
      }
    },

    saveStatusField(item, field) {
      this.$set(item, field, false);

      const userData = JSON.parse(localStorage.getItem("userData"));
      console.log("userrrr", userData);
      const manager = this.getManagerName(userData.id);

      let payload = {
        id: item.id,
        employeeID: item.employeeID,
        date: item.date,
        clockInTime: item.clockInTime,
        clockInLocation: item.clockInLocation,
        clockOutLocation: item.clockOutLocation,
        clockOutTime: item.clockOutTime,
        approverID: manager,
        hoursWorked: item.hoursWorked,
        overtimeHours: item.overtimeHours,
        status: item.status,
        notes: item.notes,
      };
      console.log("commenttest", payload);
      this.updateAttendanceAction(payload)
        .then(() => {
          this.successStatusUpdate();
          this.getAttendanceListAction({ id: null, date: null }).then(() => {
            this.totalRows = this.attendance_items.length;
          });
        })
        .catch((error) => {
          console.log(error);
          // Extract the error message from the response
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "An unexpected error occurred.";

          this.$swal({
            icon: "error",
            title: "Error!",
            text: errorMessage, // Display the extracted error message
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.showAddModal = false;
          //this.errorAdd();
        });
    },

    editRemarkField(item, field) {
      this.$set(item, field, true);
    },

    saveRemarkField(item, field) {
      this.$set(item, field, false);

      const userData = JSON.parse(localStorage.getItem("userData"));
      console.log("userrrr", userData);
      const manager = this.getManagerName(userData.id);

      let payload = {
        id: item.id,
        employeeID: item.employeeID,
        date: item.date,
        clockInTime: item.clockInTime,
        clockInLocation: item.clockInLocation,
        clockOutLocation: item.clockOutLocation,
        clockOutTime: item.clockOutTime,
        approverID: manager,
        hoursWorked: item.hoursWorked,
        overtimeHours: item.overtimeHours,
        status: item.status,
        notes: item.notes,
      };
      console.log("commenttest", payload);
      this.updateAttendanceAction(payload)
        .then(() => {
          this.successUpdate();
          this.getAttendanceListAction({ id: null, date: null }).then(() => {
            this.totalRows = this.attendance_items.length;
          });
        })
        .catch((error) => {
          console.log(error);
          // Extract the error message from the response
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "An unexpected error occurred.";

          this.$swal({
            icon: "error",
            title: "Error!",
            text: errorMessage, // Display the extracted error message
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.showAddModal = false;
          //this.errorAdd();
        });
    },

    successUpdate() {
      this.$swal({
        title: "Attendance Updated!",
        text: "You have successfully updated the Attendance remark!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    successStatusUpdate() {
      this.$swal({
        title: "Attendance Updated!",
        text: "You have successfully updated the Attendance status!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    cancelEdit(item, field) {
      this.$set(item, field, false);
      // Additional logic to reset the value if needed
    },
    refreshData() {},
    getCurrentDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
    },

    async showAddAttendanceModal() {
      this.$refs.modalAddAttendance.show();
    },
  },

  async mounted() {
    try {
      Swal.fire({
        title: "Fetching Data...",
        text: "Please wait while we load the attendance list.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      await this.getEmployeeListAction(); // Load employees first

      if (this.IsAdmin()) {
        // Admins see all attendance records
        this.currentAttendance = true;

        await this.getAttendanceListAction({ id: null, date: null }).then(
          () => {
            this.filteredAttendance = this.attendance_items.map((item) => {
              const employee = this.employeeList.find(
                (emp) => emp.id === item.employeeID
              );
              return {
                ...item,
                employeeName: employee
                  ? `${employee.firstName} ${employee.lastName}`
                  : "Unknown",
                totalMinutesWorked: item.hoursWorked,
              };
            });
            this.totalRows = this.filteredAttendance.length;
          }
        );

        await this.getAttendanceListAction({
          id: null,
          date: this.getCurrentDate(),
          currentEmployee: true,
        })
          .then(
            (res) =>
              (this.currentAttendance = this.attendance_items
                ? this.attendance_items[0]
                : null)
          )
          .catch((error) => customError(error.response.data));

        // if (this.currentAttendance == null) {
        //   await this.showAddAttendanceModal();

        //   const mauritianTime = new Date().toLocaleString("en-MU", {
        //     timeZone: "Indian/Mauritius",
        //     hour: "2-digit",
        //     minute: "2-digit",
        //     hour12: false, // For 24-hour format
        //   });

        //   // Set the clockInTime to the formatted Mauritian time
        //   this.newAttendance.clockintime = mauritianTime;

        //}
        this.whenSelected = null;

        Swal.close();
      } else {
        // Non-admin users only see their own records
        const userData = JSON.parse(localStorage.getItem("userData"));
        console.log("userData", userData);
        if (!userData || !userData.id) return;

        const emp = await this.getUser(userData.id); // Get mapped employee ID
        console.log("Mapped Employee ID:", emp);

        await this.getAttendanceListAction({ id: null, date: null }).then(
          () => {
            console.log("Attendance Items After Fetch:", this.attendance_items);

            // Filter attendance records for the logged-in employee
            this.filteredAttendance = this.attendance_items
              .filter((x) => x.employeeID === emp)
              .map((item) => {
                const employee = this.employeeList.find(
                  (emp) => emp.id === item.employeeID
                );
                return {
                  ...item,
                  employeeName: employee
                    ? `${employee.firstName} ${employee.lastName}`
                    : "Unknown",
                  totalMinutesWorked: item.hoursWorked,
                };
              });

            console.log(
              "Filtered Attendance for Non-Admin:",
              this.filteredAttendance
            );
            this.totalRows = this.filteredAttendance.length;
          }
        );
        Swal.close();
      }
    } catch (e) {
      console.error("error : ", e.message);
      Swal.error({
        title: "Error Fetching Data...",
        text: "Please wait while we load the budget list.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      Swal.close();
    }
  },
  setup() {
    return {
      IsAdmin,
    };
  },
};
</script>
